// const pick_env = "TESTING"
const pick_env = "LIVE"
let parentUrl, shareUrl, apiUrl

if (pick_env === "TESTING") {
  apiUrl = 'http://10.10.0.1:4000'
  parentUrl = "http://10.10.0.1"
  shareUrl = "http://10.10.0.1/instalevel/?share=true&language="
} else {
  apiUrl = 'https://api.instalevel.org'
  parentUrl = "https://instalevel.org"
  shareUrl = "https://instalevel.org?share=true&language="
}

export {
  apiUrl,
  parentUrl,
  shareUrl,
}



// WEBPACK FOOTER //
// ./src/js/constants/index.js